import React from 'react'
import {
   ThaiMeaningEngTranslation,
   ThaiMeaningBasicProps,
} from 'core/interfaces/dictionary-thai-interfaces'

type Props = {
   meaning: ThaiMeaningBasicProps
   engTranslationWords: ThaiMeaningEngTranslation[] | undefined
}

// The bracketed "[to]" infinitive marker is an authoring convention; render it
// as a plain "to" ("[to] run" → "to run").
const cleanMeaning = (text: string) => text.replace(/\[to\]/g, 'to')

const getTranslationComponentsFromWords = (
   words: ThaiMeaningEngTranslation[]
): React.ReactNode[] => {
   return words.map((t, index) => (
      <a
         className="text-bodyBlack text-[28px] md:text-[32px] hover:text-[hsla(212,80%,39%,1)]"
         key={index}
         href={`/?q=${t.word}`}
      >
         {cleanMeaning(t.text)}
      </a>
   ))
}

const getTranslationComponentsFromMeaningString = (meaning: string): React.ReactNode[] => {
   return meaning
      .split(';')
      .map((w) => cleanMeaning(w.trim()))
      .map((w, index) => (
         <span className="text-bodyGray text-[17px] md:text-[19px] leading-[1.5]" key={index}>
            {w}
         </span>
      ))
}

const ThaiWordMeaningText = (props: Props) => {
   if (!props.meaning.meaning) return null

   const translations: React.ReactNode[] = props.engTranslationWords
      ? getTranslationComponentsFromWords(props.engTranslationWords)
      : getTranslationComponentsFromMeaningString(props.meaning.meaning)

   const meaningsList = translations.reduce(
      (prev: React.ReactNode, curr: React.ReactNode, idx: number) => [
         prev,
         <span className="mr-[0.3em]" key={`Divider ${idx}`}>
            ,
         </span>,
         curr,
      ]
   )

   const wrapperClass = props.engTranslationWords ? 'text-bodyBlack' : 'text-bodyGray'

   return <span className={wrapperClass}>{meaningsList}</span>
}

export default ThaiWordMeaningText
